import { useEffect, useState } from "react";
import Api, { MyQuotesListResponse, MyQuotesQueueResponse } from "../../Api";
import DiscreetMessage from "../../parts/DiscreetMessage";

const ListQueue = () => {
  const [data, setData] = useState<MyQuotesQueueResponse | null>(null);

  useEffect(() => {
    Api.myQuotesQueue().then(setData);
  }, []);

  if (!data) return <DiscreetMessage text="Carregando" />;

  if (
    data.allocated.length === 0 &&
    data.queued.length === 0 &&
    data.pending.length === 0
  )
    return <DiscreetMessage text="Nenhuma instalação na fila" />;

  return (
    <div className="flex flex-col gap-6 px-4">
      {data.allocated.length > 0 && (
        <div>
          <Title label="Alocados" />
          <CardList items={data.allocated} />
        </div>
      )}

      {(data.queued.length > 0 || data.remaining.length > 0) && (
        <div>
          <Title label="Na fila" />
          <CardList items={data.remaining.concat(data.queued)} />
        </div>
      )}

      {data.contractPending.length > 0 && (
        <div>
          <Title label="Contrato pendente" />
          <CardList items={data.contractPending} />
        </div>
      )}

      {data.pending.length > 0 && (
        <div>
          <Title label="Outras pendências" />
          <CardList items={data.pending} />
        </div>
      )}
    </div>
  );
};

export default ListQueue;

const CardList = ({ items }: { items: MyQuotesListResponse[] }) => {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <Card key={item.uuid} item={item} />
      ))}
    </div>
  );
};

const Card = ({ item }: { item: MyQuotesListResponse }) => {
  return (
    <div className="border rounded-lg shadow-sm flex items-stretch">
      <div className="p-2 border-r font-mono text-xs flex items-center bg-gray-100 text-gray-600 rounded-l-lg">
        {item.quote.number}
      </div>
      <div className="p-2 font-semibold overflow-scroll whitespace-nowrap no-scrollbar">
        {item.clientName}
      </div>
    </div>
  );
};

const Title = ({ label }: { label: string }) => {
  return <div className="font-light text-sm text-center mb-1">{label}</div>;
};
